import React, { useState } from 'react';
import { Users, Clock, DollarSign, Download, Plus, Search, Filter, MoreVertical, Calendar, ArrowUpRight, ArrowDownRight } from 'lucide-react';
const employees = [{
  id: 1,
  name: 'Sarah Johnson',
  role: 'Head Chef',
  rate: 35.0,
  hours: 42,
  status: 'Active',
  avatar: 'SJ'
}, {
  id: 2,
  name: 'Michael Chen',
  role: 'Sous Chef',
  rate: 28.0,
  hours: 38,
  status: 'Active',
  avatar: 'MC'
}, {
  id: 3,
  name: 'Emma Wilson',
  role: 'Server',
  rate: 15.0,
  hours: 25,
  status: 'Active',
  avatar: 'EW'
}, {
  id: 4,
  name: 'David Rodriguez',
  role: 'Bartender',
  rate: 18.0,
  hours: 32,
  status: 'Active',
  avatar: 'DR'
}, {
  id: 5,
  name: 'Lisa Thompson',
  role: 'Hostess',
  rate: 16.0,
  hours: 20,
  status: 'On Leave',
  avatar: 'LT'
}];
export function PayrollView() {
  const [searchTerm, setSearchTerm] = useState('');
  return <div className="space-y-6" data-id="element-1352">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-1353">
        <div data-id="element-1354">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-1355">
            Payroll Management
          </h2>
          <p className="text-sm text-slate-500" data-id="element-1356">
            Track hours, manage rates, and process payroll
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-1357">
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-xl text-sm font-bold text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-1358">
            <Download size={16} data-id="element-1359" />
            Export Report
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-slate-900 text-white rounded-xl text-sm font-bold hover:bg-slate-800 transition-all shadow-lg shadow-slate-900/20" data-id="element-1360">
            <Plus size={16} data-id="element-1361" />
            Add Employee
          </button>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1362">
        <StatCard label="Total Payroll (MTD)" value="$24,850" change="+5.2%" isUp icon={DollarSign} color="blue" data-id="element-1363" />
        <StatCard label="Total Hours" value="1,240h" change="-2.1%" icon={Clock} color="emerald" data-id="element-1364" />
        <StatCard label="Active Employees" value="18" change="0" icon={Users} color="purple" data-id="element-1365" />
        <StatCard label="Avg. Hourly Rate" value="$22.40" change="+1.2%" isUp icon={DollarSign} color="amber" data-id="element-1366" />
      </div>

      {/* Main Content */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-1367">
        <div className="p-6 border-b border-slate-50 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-1368">
          <div className="relative flex-1 max-w-md" data-id="element-1369">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-1370" />
            <input type="text" placeholder="Search employees..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 bg-slate-50 border-none rounded-xl text-sm focus:ring-2 focus:ring-slate-900/5 transition-all" data-id="element-1371" />
          </div>
          <div className="flex items-center gap-2" data-id="element-1372">
            <button className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-lg transition-all" data-id="element-1373">
              <Filter size={20} data-id="element-1374" />
            </button>
            <button className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-lg transition-all" data-id="element-1375">
              <Calendar size={20} data-id="element-1376" />
            </button>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-1377">
          <table className="w-full text-left" data-id="element-1378">
            <thead data-id="element-1379">
              <tr className="bg-slate-50/50" data-id="element-1380">
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-1381">
                  Employee
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-1382">
                  Role
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-1383">
                  Hourly Rate
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-1384">
                  Hours (WTD)
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-1385">
                  Gross Pay
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-1386">
                  Status
                </th>
                <th className="px-6 py-4" data-id="element-1387"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50" data-id="element-1388">
              {employees.map(emp => <tr key={emp.id} className="hover:bg-slate-50/50 transition-colors group" data-id="element-1389">
                  <td className="px-6 py-4" data-id="element-1390">
                    <div className="flex items-center gap-3" data-id="element-1391">
                      <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-[10px] font-bold text-slate-600" data-id="element-1392">
                        {emp.avatar}
                      </div>
                      <span className="text-sm font-bold text-slate-900" data-id="element-1393">
                        {emp.name}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-500 font-medium" data-id="element-1394">
                    {emp.role}
                  </td>
                  <td className="px-6 py-4 text-sm font-bold text-slate-900" data-id="element-1395">
                    ${emp.rate.toFixed(2)}
                  </td>
                  <td className="px-6 py-4 text-sm font-bold text-slate-900" data-id="element-1396">
                    {emp.hours}h
                  </td>
                  <td className="px-6 py-4 text-sm font-black text-slate-900" data-id="element-1397">
                    ${(emp.rate * emp.hours).toLocaleString()}
                  </td>
                  <td className="px-6 py-4" data-id="element-1398">
                    <span className={`px-2 py-1 rounded-full text-[10px] font-bold uppercase ${emp.status === 'Active' ? 'bg-emerald-50 text-emerald-600' : 'bg-amber-50 text-amber-600'}`} data-id="element-1399">
                      {emp.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-1400">
                    <button className="p-1 text-slate-400 hover:text-slate-600 opacity-0 group-hover:opacity-100 transition-all" data-id="element-1401">
                      <MoreVertical size={16} data-id="element-1402" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="p-6 border-t border-slate-50 bg-slate-50/30" data-id="element-1403">
          <div className="flex items-center justify-between" data-id="element-1404">
            <p className="text-xs text-slate-500 font-medium" data-id="element-1405">
              Showing 5 of 18 employees
            </p>
            <div className="flex gap-2" data-id="element-1406">
              <button className="px-3 py-1 bg-white border border-slate-200 rounded-lg text-xs font-bold text-slate-400 cursor-not-allowed" data-id="element-1407">
                Previous
              </button>
              <button className="px-3 py-1 bg-white border border-slate-200 rounded-lg text-xs font-bold text-slate-600 hover:bg-slate-50" data-id="element-1408">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}
function StatCard({
  label,
  value,
  change,
  isUp,
  icon: Icon,
  color
}: any) {
  const colors: any = {
    blue: 'bg-blue-50 text-blue-600',
    emerald: 'bg-emerald-50 text-emerald-600',
    purple: 'bg-purple-50 text-purple-600',
    amber: 'bg-amber-50 text-amber-600'
  };
  return <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-1409">
      <div className="flex items-center justify-between mb-4" data-id="element-1410">
        <div className={`p-2 rounded-xl ${colors[color]}`} data-id="element-1411">
          <Icon size={20} data-id="element-1412" />
        </div>
        {change !== '0' && <div className={`flex items-center gap-0.5 text-xs font-bold ${isUp ? 'text-emerald-600' : 'text-rose-600'}`} data-id="element-1413">
            {isUp ? <ArrowUpRight size={14} data-id="element-1414" /> : <ArrowDownRight size={14} data-id="element-1415" />}
            {change}
          </div>}
      </div>
      <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-1416">
        {label}
      </p>
      <p className="text-2xl font-black text-slate-900" data-id="element-1417">{value}</p>
    </div>;
}